import { mfsErrorHandler } from '../errors/mfsErrorHandler';
import { MFS_CARD_TYPE } from './constant/constants';
import { logger } from './telemetry';
import { getMfsItem } from './utils';
/** The property name for 'updatedAt' field for a Card.  */
export const UPDATED_AT_PROPERTY_NAME = 'updatedAt';
/** The property name for 'inUse' field for a Tag. */
export const TAG_IN_USE_PROPERTY_NAME = 'inUse';
/** Concrete implementation to update the properties(item properties and tags) for a Card. */
export class CardPropertyUtils {
    constructor(dataStore) {
        this.dataStore = dataStore;
    }
    /**
     * Update target Card's `updatedAt` property value to be the epoch timestamp in miliseconds at current point of time.
     * A new property will be created on the MfsItem if target item does not have such property before.
     *
     * Does not throw errors. Errors are logged and swallowed.
     *
     * @param cardId The uniqueId of target Card
     */
    async refreshUpdatedAtTimeByIdSafe(cardId) {
        const mfsCard = getMfsItem(this.dataStore, cardId, MFS_CARD_TYPE);
        if (!mfsCard)
            return;
        return this.refreshUpdatedAtTimeSafe(mfsCard);
    }
    /**
     * Update target Card's `updatedAt` property value to be the epoch timestamp in miliseconds at current point of time.
     * A new property will be created on the MfsItem if target item does not have such property before.
     *
     * Does not throw errors. Errors are logged and swallowed.
     *
     * @param mfsCard The MfsCard type representation for target Card
     */
    async refreshUpdatedAtTimeSafe(mfsCard) {
        return this.updateMfsItemProperty(mfsCard, UPDATED_AT_PROPERTY_NAME, Date.now(), 'refreshedUpdatedAtTime');
    }
    /**
     * Update the `inUse` status for the target Tag when its current status does not match desired status.
     *
     * Error will be logged and swallowed if exist.
     *
     * @param mfsTag The MfsTag type representation for target Tag.
     * @param newValue Desired value for a Tag's inUse status.
     */
    async updateTagInUseStatus(mfsTag, newValue) {
        let currValue;
        try {
            currValue = this.dataStore.getItemProperty(mfsTag.id, TAG_IN_USE_PROPERTY_NAME);
            logger.logVerbose('updateTagInUseStatus', `Tag ${TAG_IN_USE_PROPERTY_NAME} property value`, {
                tagItemId: mfsTag.id,
                currentValue: currValue,
            });
        }
        catch (err) {
            logger.logVerbose('updateTagInUseStatus', `Encountered error when reading ${TAG_IN_USE_PROPERTY_NAME} property, skip and directly update instead.`, { error: err, tagItemId: mfsTag.id });
        }
        if (!currValue || currValue !== newValue) {
            return this.updateMfsItemProperty(mfsTag, TAG_IN_USE_PROPERTY_NAME, newValue, 'updateTagInUseStatus');
        }
    }
    /**
     * Helper function to update the target property field of an MfsItem to its desired value.
     * When encountering unexpected errors, this function will log error and retry one time before moving forward.
     */
    async updateMfsItemProperty(mfsItem, propertyName, desiredValue, eventName) {
        try {
            logger.logVerbose('updateMfsItemProperty', 'Updating property value.', {
                itemId: mfsItem.id,
                eventName,
            });
            return this.dataStore.setItemProperty(mfsItem.id, propertyName, desiredValue);
        }
        catch (err) {
            mfsErrorHandler(`Failed to update the property for itemId ${mfsItem.id}. Retrying one more time: ${err}`, err, eventName);
            try {
                return this.dataStore.setItemProperty(mfsItem.id, propertyName, desiredValue);
            }
            catch (err) {
                mfsErrorHandler(`Failed to update the property for ${mfsItem.id}: ${err}`, err, eventName);
            }
        }
    }
}
//# sourceMappingURL=cardPropertyUtils.js.map